import { ManagePeopleApptsScreeningPage } from './manage-people-appts-screening.page';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: ManagePeopleApptsScreeningPage,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManagePeopleApptsScreeningPageRoutingModule {}
